import React from 'react';

interface WorkflowFlowProps {
  currentStage?: string;
  stages?: string[];
  onStageClick?: (stage: string) => void;
  userRole?: string;
  isLocked?: boolean;
  recordId?: string;
  stageCounts?: Record<string, number>;
  simpleHighlight?: boolean;
}

const WorkflowFlow: React.FC<WorkflowFlowProps> = ({
  currentStage = 'Register ICSR information',
  stages = [
    'Register ICSR information',
    'Review',
    'Quality Check',
    'Submission',
    'Completed'
  ],
  stageCounts,
}) => {
  const getStageColor = (index: number) => {
    const colors = [
      'from-blue-500 to-blue-600',
      'from-indigo-500 to-indigo-600', 
      'from-purple-500 to-purple-600',
      'from-green-500 to-green-600',
      'from-emerald-500 to-emerald-600'
    ];
    return colors[index % colors.length];
  };

  const getStageIcon = (index: number) => {
    const icons = [
      'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
      'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
      'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253',
      'M5 13l4 4L19 7'
    ];
    return icons[index % icons.length];
  };

  return (
    <div className="px-8 py-6">
      <div className="flex items-center justify-center space-x-4 overflow-x-auto pb-2">
        {stages.map((stage, index) => (
            <React.Fragment key={stage}>
            <div className="flex flex-col items-center min-w-0 flex-shrink-0">
              <div className={`w-16 h-16 bg-gradient-to-br ${getStageColor(index)} rounded-xl flex items-center justify-center shadow-lg mb-3`}>
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={getStageIcon(index)} />
                </svg>
              </div>
              <div className="text-center">
                <div className="text-sm font-semibold text-gray-900 mb-1 whitespace-nowrap max-w-24">
                  {stage}
                </div>
                <div className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                  <span className="w-2 h-2 bg-gray-400 rounded-full mr-2"></span>
                  {typeof stageCounts?.[stage] === 'number' ? `${stageCounts[stage]} case${stageCounts[stage] !== 1 ? 's' : ''}` : '0 cases'}
          </div>
        </div>
            </div>
            {index < stages.length - 1 && (
              <div className="flex items-center mx-2">
                <svg className="w-6 h-6 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
                </div>
              )}
            </React.Fragment>
        ))}
      </div>
    </div>
  );
};

// Removed instructions and interactive/visual adornments to keep diagram simple

export default WorkflowFlow;
